import { render, staticRenderFns } from "./ProfileBankingForm.vue?vue&type=template&id=2b88adf7"
import script from "./ProfileBankingForm.vue?vue&type=script&lang=ts"
export * from "./ProfileBankingForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports